import React from 'react';
import PropTypes from 'prop-types';
import * as styles from 'styles/index.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { appSideBarItemContainer, appSideBarItemIcon, appSideBarItemTitle } = styles;

const SideBarItem = ({ handleClick, icon, title, iconStyles }) => (
  <div className={appSideBarItemContainer}>
    <div
      className={appSideBarItemTitle}
      onClick={handleClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') handleClick?.(e);
      }}
      role="button"
      tabIndex={0}
    >
      <div className={appSideBarItemIcon}>
        <FontAwesomeIcon icon={icon} color="white" {...(iconStyles ? { styles: iconStyles } : {})} />
      </div>
      <div>
        <span>{title}</span>
      </div>
    </div>
  </div>
);

SideBarItem.propTypes = {
  handleClick: PropTypes.func,
  icon: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired
};

export default SideBarItem;
